import { useEffect, useState } from "react";
import { DECO_ICONS } from "@/components/holiday/useHoliday";
import { playHoliday } from "@/components/holiday/holidaySound";

const N = 7;
let seq = 0;

export const ClickBurst = ({ theme }) => {
  const [bursts, setBursts] = useState([]);
  useEffect(() => {
    const still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const on = (e) => {
      const el = e.target.closest?.("button, a, [role=button]");
      if (!el || el.closest("[data-holiday-silent]")) return;
      playHoliday(theme.id);
      if (still) return;
      const id = ++seq;
      setBursts((b) => [...b.slice(-4), { id, x: e.clientX, y: e.clientY }]);
      setTimeout(() => setBursts((b) => b.filter((x) => x.id !== id)), 900);
    };
    document.addEventListener("click", on, true);
    return () => document.removeEventListener("click", on, true);
  }, [theme.id]);
  const icons = DECO_ICONS[theme.deco] || DECO_ICONS.snow;
  return (
    <div className="fixed inset-0 pointer-events-none z-[90]" aria-hidden="true" data-testid="holiday-click-burst">
      {bursts.map((b) => Array.from({ length: N }, (_, i) => {
        const a = (i / N) * Math.PI * 2 + b.id;
        const r = 34 + ((i * 17 + b.id) % 22);
        const Icon = icons[i % icons.length];
        return (
          <span key={`${b.id}-${i}`} className="cx-hol-burst" data-testid="holiday-burst-particle"
            style={{ left: b.x, top: b.y, color: i % 2 ? theme.color2 : theme.color, "--dx": `${Math.cos(a) * r}px`, "--dy": `${Math.sin(a) * r - 14}px`, "--rot": `${(i % 2 ? 1 : -1) * 160}deg` }}>
            <Icon className="w-3.5 h-3.5" />
          </span>
        );
      }))}
    </div>
  );
};
